module.exports = __webpack_public_path__ + "img/console.b4f11688.png";